import React from 'react';

import './styles.css';


const HomeIntro = (props) => {
  return (
    <React.Fragment>
        <div className="home-intro bg-primary mb-0">
          <div className="container">
            <div className="d-flex align-items-center justify-content-center">
                <h2>
                  { props?.setting?.home_intro_title }
                </h2>
                <div className="get-started text-start text-lg-end ms-4">
                  <a
                    href={props?.setting?.home_intro_btn_link}
                    className="contact-btn btn btn-borders btn-dark btn-lg text-3 font-weight-semibold px-4 py-3"
                  >
                    { props?.setting?.home_intro_btn_text }
                  </a>
              </div>
            </div>
          </div>
        </div>
    </React.Fragment>
  );
};

export default HomeIntro;
